import {
  GET_EMAIL_SETUP,
  GET_EMAIL_SETUP_FAILED,
  GET_EMAIL_SETUP_SUCCESS,
  GET_VISITOR_LIST,
  GET_VISITOR_LIST_FAILED,
  GET_VISITOR_LIST_SUCCESS,
  UPDATE_EMAIL_SETUP,
  UPDATE_EMAIL_SETUP_FAILED,
  UPDATE_EMAIL_SETUP_SUCCESS,
} from "./actionTypes"

export const getVisitorList = params => ({
  type: GET_VISITOR_LIST,
  payload: params,
})

export const getVisitorListSuccess = response => ({
  type: GET_VISITOR_LIST_SUCCESS,
  payload: response,
})

export const getVisitorListFailed = error => ({
  type: GET_VISITOR_LIST_FAILED,
  payload: error,
})

export const getEmailSetup = params => ({
  type: GET_EMAIL_SETUP,
  payload: params,
})

export const getEmailSetupSuccess = response => ({
  type: GET_EMAIL_SETUP_SUCCESS,
  payload: response,
})

export const getEmailSetupFailed = error => ({
  type: GET_EMAIL_SETUP_FAILED,
  payload: error,
})

export const updateEmailSetup = params => ({
  type: UPDATE_EMAIL_SETUP,
  payload: params,
})

export const updateEmailSetupSuccess = response => ({
  type: UPDATE_EMAIL_SETUP_SUCCESS,
  payload: response,
})

export const updateEmailSetupFailed = error => ({
  type: UPDATE_EMAIL_SETUP_FAILED,
  payload: error,
})
